module.exports = __webpack_public_path__ + "img/polis-logo.4d43e643.svg";